import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.scss';

const SectionTitle = ({ title }) => (
  <div className={`mb-1 ${styles.title}`}>
    <b>{title}</b>
  </div>
);

SectionTitle.propTypes = {
  title: PropTypes.string,
};

export default SectionTitle;



// WEBPACK FOOTER //
// src/components/shared/SectionTitle/index.jsx